var map = {
	"./4027be-1.svg": "jIde",
	"./4049bp-1.svg": "Nbt6",
	"./555-1.svg": "QN3E",
	"./74HC08-1.svg": "0K0O",
	"./74LS47-1.svg": "9JoN",
	"./74hc00n-1.svg": "zkxk",
	"./74hc32-1.svg": "bN91",
	"./EmissorReceptorIR-1.svg": "dINq",
	"./LedRGB-1.svg": "G+Cq",
	"./SensorPIR-1.svg": "ZWBI",
	"./adaptadorEsp01-1.svg": "k/CV",
	"./arduino.svg": "6w0H",
	"./arduinoUnoDIP-1.svg": "opdd",
	"./arduino_mega_2560_cabo-1.svg": "pc73",
	"./arduino_mega_2560_cabo-2.svg": "ANzQ",
	"./arduino_nano-1.svg": "Ly1O",
	"./arduino_nano-2.svg": "uaq4",
	"./arduino_nano-3.svg": "g2ki",
	"./arduino_uno-1.svg": "u2FQ",
	"./arduino_uno-2.svg": "t3XP",
	"./bcd7seg-1.svg": "BCrT",
	"./borne2-1.svg": "QJo8",
	"./buzzer-1.svg": "ySnk",
	"./buzzer12v-1.svg": "cABg",
	"./buzzer3v-1 (2).svg": "B63g",
	"./buzzer3v-1.svg": "UJes",
	"./buzzer_passivo-1.svg": "ahpi",
	"./caboArduino-1.svg": "zidy",
	"./caboArduinoNano-1.svg": "z4uj",
	"./capacitor_ceramico-1.svg": "KD0s",
	"./capacitor_eletrolitico-1.svg": "AaHv",
	"./cardRFID-1.svg": "NDdd",
	"./cd4013-1.svg": "i/Y2",
	"./cd4511be-1.svg": "srjj",
	"./cd4518be-1.svg": "u7bN",
	"./clipe_bateria-1.svg": "DOH2",
	"./conversorI2c-1.svg": "LEyG",
	"./dht11-1.svg": "eVeh",
	"./diodo-1.svg": "Zv0a",
	"./diodo_zener-1.svg": "3ZUV",
	"./display_lcd_azul_16x2-1.svg": "oF/O",
	"./display_lcd_azul_16x2_i2c-1.svg": "Us+m",
	"./display_lcd_azul_16x2_i2c-2.svg": "WYE2",
	"./esp32-1.svg": "R99r",
	"./esp_8266-1.svg": "8bd3",
	"./esp_8266-2.svg": "+pA5",
	"./fonteProtoboard-1.svg": "oN/w",
	"./higrometro-1.svg": "U8ru",
	"./joystick-1.svg": "67bC",
	"./jumperU-1.svg": "6bSB",
	"./jumper_ff-1.svg": "k8SP",
	"./jumper_ff_20-1.svg": "f40t",
	"./jumper_mf-1.svg": "0ot8",
	"./jumper_mf_20-1.svg": "ocMg",
	"./jumper_mm-1.svg": "bOAw",
	"./jumper_mm_20-1.svg": "yluL",
	"./knob_potenciometro-1.svg": "bJLE",
	"./l293d-1.svg": "//Qi",
	"./l7805cv-1.svg": "e6KH",
	"./ldr_5mm-1.svg": "J5YW",
	"./led-light.svg": "fWam",
	"./led3mm.svg": "ZX/Z",
	"./led5mm.svg": "l5Sd",
	"./led_ab-1.svg": "bDld",
	"./led_difuso_amarelo_3mm-1.svg": "smak",
	"./led_difuso_amarelo_5mm-1.svg": "u6lI",
	"./led_difuso_azul_3mm-1.svg": "o5AU",
	"./led_difuso_azul_5mm-1.svg": "p4ic",
	"./led_difuso_branco_3mm-1.svg": "9cTr",
	"./led_difuso_branco_5mm-1.svg": "8DCm",
	"./led_difuso_verde_3mm-1.svg": "CWlZ",
	"./led_difuso_verde_5mm-1.svg": "ajtw",
	"./led_difuso_vermelho_3mm-1.svg": "AMmb",
	"./led_difuso_vermelho_5mm-1.svg": "6f1k",
	"./lm35l-1.svg": "Ty5K",
	"./lm386-1.svg": "RqAP",
	"./moduloBidirecional-1.svg": "GQ7r",
	"./moduloRele2-1.svg": "K+o3",
	"./modulo_bluetooth_at_09-1.svg": "XZq4",
	"./modulo_bluetooth_hc_05-1.svg": "J6bH",
	"./modulo_bluetooth_hc_05-2.svg": "zMyT",
	"./modulo_rele_1_canal_5v-1.svg": "pGeK",
	"./modulo_rele_1_canal_5v-2.svg": "VC3i",
	"./motor_roda-1.svg": "u40L",
	"./mpu-1.svg": "MgQ0",
	"./multimeter.svg": "9Pnc",
	"./nodeMCU_1.0-1.svg": "sPzl",
	"./pcbIlhada-1.svg": "DwkP",
	"./pinHeader-1.svg": "RFgz",
	"./ponteH_l293D-1.svg": "IDu2",
	"./ponteH_ln298n-1.svg": "5Alj",
	"./potenciometro_100k-1.svg": "nZcE",
	"./potenciometro_50k-1.svg": "YemF",
	"./potenciometro_5k-1.svg": "/ys4",
	"./protoboard_170-1.svg": "/AU8",
	"./protoboard_400-1.svg": "rryp",
	"./protoboard_830-1.svg": "a2ZB",
	"./reg_tesn_12v-1.svg": "o777",
	"./reg_tesn_15v-1.svg": "dOao",
	"./reg_tesn_9v-1.svg": "xTYp",
	"./resistor_10k-1.svg": "RPQ3",
	"./rfid_mfrc_522-1.svg": "6Vbv",
	"./robocop.svg": "3zDz",
	"./sensorMq2-1.svg": "tE7t",
	"./sensorVibracao-1.svg": "48mF",
	"./sensor_chuva-1.svg": "3lDc",
	"./sensor_optico_tcrt5000-1.svg": "Nnpj",
	"./sensor_optico_tcrt5000-2.svg": "StCA",
	"./sensor_ultrassonico_hc_sr04-1.svg": "1Zqc",
	"./sensor_ultrassonico_hc_sr04-2.svg": "12iF",
	"./servo_sg90-1.svg": "8jBN",
	"./tecladoMatricial-1.svg": "c07r",
	"./tl1838-1.svg": "MyUY",
	"./tokenRFID-1.svg": "4vCU",
	"./transistor-1.svg": "hGbI",
	"./wemos_d1_mini-1.svg": "nYZ0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eReo";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos nonrecursive \.svg$
// module id = eReo
// module chunks = 0